import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import styles from './SignupPage.module.css';
import UserDetails from './UserDetails';
import LeftRegisterText from './LeftRegisterText';
import LeftPaymentText from './LeftPaymentText';
// import useDFScript from '../../hooks/useDFScript';

import {
  // selectLoading,
  // selectPaymentType,
  selectRedirectUrl,
  selectShowPaymentDetailsForm,
  selectTrialInDays,
} from '../../store/selectors';
import { fetchConfig, changeSelectedPaymentType, forceTrialDays } from '../../store';

import Image from '../../../../components/elements/Image';
import Brands from './Brands';
import PaymentDetails from './PaymentDetails';

const stripePromise = loadStripe(process.env.STRIPE_PUBLIC || 'empty');

const SignupPage = ({
  special,
  plan,
  location,
  funnel = 'cc',
  forcePaymentForm = false,
  signupTitle = false,
  trackingCode = false,
  leftHeadline = false,
  confirmTitle = '',
  hidePlanDescription = false,
  forceTrialInDays = false,
  priceOff = 0,
  hideAnnual = false,
  couponId = null,
}) => {
  const selectedPaymentForm = useSelector(selectShowPaymentDetailsForm);
  const showPaymentDetailsForm = forcePaymentForm || (selectedPaymentForm && funnel === 'cc');

  const redirectUrl = useSelector(selectRedirectUrl);
  // const loading = useSelector(selectLoading);
  // const paymentType = useSelector(selectPaymentType);
  const trialInDays = useSelector(selectTrialInDays);
  const dispatch = useDispatch();

  const redirectDomain = process.env.APP_URL;

  useEffect(() => {
    if (redirectUrl) {
      if (redirectUrl.includes("success")) {
        window.location.assign(redirectUrl);
      } else {
        window.location.assign(`${process.env.APP_URL}${redirectUrl}`);
      }
    } 
  }, [redirectUrl]);

  useEffect(() => {
    if (plan) {
      dispatch(fetchConfig({ plan, special, priceOff, forceTrialInDays }));
    }
  }, [plan, dispatch, special]);

  useEffect(() => {
    if (!special) {
      dispatch(changeSelectedPaymentType('month'));
    }
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className={`${styles.headContainer} d-flex flex-column align-items-center`}>
          <Image name="signup-firework" className={styles.fireworkImage} />
          <h1 className={styles.headline}>
            {signupTitle ? signupTitle : `Start Your ${trialInDays > 0 ? trialInDays : 14}-Day Free Trial!`}
          </h1>
          <p className={styles.subHeadline}>
            Join over 3,500 course creators and make more sales to a bigger audience with less effort.
          </p>
          {trackingCode && (
            <h5>
              After <span class="deadlinetext">the Deadline</span> This Discount Expires
            </h5>
          )}
        </div>
        <div className={`${styles.contentContainer} d-flex row`}>
          <div className={styles.leftContent}>
            <h3 className={styles.leftHeadline}>
              {leftHeadline ? leftHeadline : `What’s Included in The Free Trial?`}
            </h3>
            {!showPaymentDetailsForm && <LeftRegisterText />}
            {showPaymentDetailsForm && <LeftPaymentText plan={plan} />}
            <div className={styles.whoUsing}>
              <h3 className={styles.useTitle}>Deadline Funnel has been featured in…</h3>
              <Brands />
            </div>
          </div>
          <div className={styles.rightContent}>
            {!showPaymentDetailsForm && <UserDetails funnel={funnel} />}
            {showPaymentDetailsForm && (
              <Elements stripe={stripePromise}>
                <PaymentDetails
                  plan={plan}
                  location={location}
                  forceTrialInDays={forceTrialInDays}
                  hideAnnual={hideAnnual}
                  couponId={couponId}
                  funnel={funnel}
                  confirmTitle={confirmTitle}
                  hidePlanDescription={hidePlanDescription}
                />
              </Elements>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;
